export default "__VITE_ASSET__CTuWuCoZ__"